module.exports = __webpack_public_path__ + "assets/img/activity_invite.3af5bf8f.png";